import { useContext, useState } from "react";
import UiContext from "../../../../store/ui-context";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import { endOfMonth, format, startOfMonth } from "date-fns";

export const useAPIgetCustomer = () => {
  const uiContext = useContext(UiContext);
  const { requestGetOne, requestGet, loading } = useAPIRequest();
  const [data, setData] = useState(null);
  const [error, setError] = useState({});

  const [filterValue, setFilterValue] = useState({
    search: "",
    bc_id: 0,
  });

  const fetchData = async ({ id }) => {
    if (!validate()) {
      return;
    }
    const newFilter =
      getFilter(filterValue) +
      `;expired_date:>=:${format(
        new Date(),
        "yyyy-MM-dd"
      )};usage_date:=:Null;data_product.id:=:${id};`;

    return requestGet({
      fullUrl: `/api/report`,
      params: {
        prefix: "customer_free_product",
        page: 1,
        take: 10000000,
        filter: newFilter,
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message, pagination }) => {
        setData({
          customers: _data,
          total_packages: sumAll(_data, "quantity"),
        });
      },
    });
  };

  const sumAll = (items, field) => {
    if (!Array.isArray(items) || items.length === 0) return 0;

    return items.reduce((sum, item) => {
      const value = item[field];
      return sum + (typeof value === "number" ? value : 0);
    }, 0);
  };

  const getFilter = (_filterValue) => {
    const filterArr = [];
    const newFilterValue = _filterValue ?? filterValue;

    if (newFilterValue.bc_id && newFilterValue.bc_id !== 0) {
      filterArr.push(`data_customer.bc_id:=:${newFilterValue.bc_id}`);
    }

    if (newFilterValue.search) {
      filterArr.push(
        `data_customer.name:contains:${newFilterValue.search}||data_customer.code:contains:${newFilterValue.search}`
      );
    }

    return filterArr.join(";");
  };

  const validate = () => {
    let isValid = true;

    return isValid;
  };

  return {
    data,
    setData,
    error,
    setError,
    fetchData,
    filterValue,
    setFilterValue,
    loading,
  };
};
